module.exports = __webpack_public_path__ + "img/55b295c7d62c6a3a76c7619f2b7103yy.2955be4a.jpg";